/**
 * 오브젝트와 오브젝트를 결합한다.
 */

export const combineObject = (object1, object2) => {
  const object3 = {};
  for (let i in object1) object3[i] = object1[i];
  for (let i in object2) {
    if (typeof object2[i] === "object" && !Array.isArray(object2[i]))
      object3[i] = combineObject(object3[i], object2[i]);
    else object3[i] = object2[i];
  }
  return object3;
};

/**
 * compare objects
 */
export const compareObjects = (x, y) => {
  if (x === y) return true;
  // if both x and y are null or undefined and exactly the same

  if (!(x instanceof Object) || !(y instanceof Object)) return false;
  // if they are not strictly equal, they both need to be Objects

  if (x.constructor !== y.constructor) return false;
  // they must have the exact same prototype chain, the closest we can do is
  // test their constructor.

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue;
    // other properties were tested using x.constructor === y.constructor

    if (!y.hasOwnProperty(p)) return false;
    // allows to compare x[ p ] and y[ p ] when set to undefined

    if (x[p] === y[p]) continue;
    // if they have the same strict value or identity then they are equal

    if (typeof x[p] !== "object") return false;
    // Numbers, Strings, Functions, Booleans must be strictly equal

    if (!compareObjects(x[p], y[p])) return false;
    // Objects and Arrays must be tested recursively
  }

  for (p in y) if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
  // allows x[ p ] to be set to undefined

  return true;
};

export default { combineObject, compareObjects };
